import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import SummaryInfoPage from './SummaryInfoPage';

const SummaryInfoPageRoute: FuseRouteItemType = {
  path: '',
  element: <SummaryInfoPage />,
};

export default SummaryInfoPageRoute;
